module.exports = __webpack_public_path__ + "media/images/common/ui/btn_dokanto-a9b29939dc2a54c971472c6ee93d44ae.png";